import { StepsContainer } from '@roc/ui';
import { observer } from 'mobx-react';
import { CreditInformation } from '../../creditInformation';
import { PersonalInformation } from '../../personalInformation';
import { PublicCreditInformation } from '../../public/publicCreditInformation';

export const PersonalAndCreditInformationSteps = observer((props) => {

  const { store, handleClose } = props;
  const { activeStep, isBorrowerUser, personalGuarantor } = store;

  const steps = [
    {
      title: 'Personal Information',
      icon: null,
      onNext: async () => {
        store.savePersonalInformation();
      },
      allowBack: false,
      allowNext: true,
    },
    {
      title: 'Credit Information',
      icon: null,
      onBack: () => {
        store.goPrevStep();
      },
      onNext: async () => {
        store.saveCreditInformation(handleClose);
      },
      allowBack: true,
      allowNext: !isBorrowerUser,
      nextButtonText: 'Finish',
    },
  ];

  const getCreditContent = () => {
    return isBorrowerUser && personalGuarantor
      ? <PublicCreditInformation store={store} handleClose={handleClose} />
      : <CreditInformation store={store} />
  };

  const getStepsContent = () => {
    return [
      <PersonalInformation store={store} />,
      getCreditContent()
    ];
  };

  return (
    <StepsContainer
      activeStep={activeStep}
      disableNavigation={true}
      steps={steps}
    >
      {getStepsContent()}
    </StepsContainer>
  )
});